// src/common.ts
var Status = /* @__PURE__ */ ((Status2) => {
  Status2["ACTIVE"] = "active";
  Status2["INACTIVE"] = "inactive";
  Status2["PENDING"] = "pending";
  Status2["ARCHIVED"] = "archived";
  return Status2;
})(Status || {});

// src/user.ts
var UserRole = /* @__PURE__ */ ((UserRole2) => {
  UserRole2["ADMIN"] = "admin";
  UserRole2["TENANT_ADMIN"] = "tenant_admin";
  UserRole2["JUNIPER_OPERATOR"] = "juniperOperator";
  return UserRole2;
})(UserRole || {});

// src/invoice.ts
var InvoiceStatus = /* @__PURE__ */ ((InvoiceStatus2) => {
  InvoiceStatus2["DRAFT"] = "draft";
  InvoiceStatus2["PENDING"] = "pending";
  InvoiceStatus2["SENT"] = "sent";
  InvoiceStatus2["PAID"] = "paid";
  InvoiceStatus2["OVERDUE"] = "overdue";
  InvoiceStatus2["CANCELLED"] = "cancelled";
  return InvoiceStatus2;
})(InvoiceStatus || {});

// src/auth.ts
var LoginProvider = /* @__PURE__ */ ((LoginProvider2) => {
  LoginProvider2["GOOGLE"] = "Google";
  LoginProvider2["MICROSOFT"] = "Microsoft";
  LoginProvider2["Clio"] = "Clio";
  return LoginProvider2;
})(LoginProvider || {});

// src/reports.ts
var ArExceptionFlag = /* @__PURE__ */ ((ArExceptionFlag2) => {
  ArExceptionFlag2["OK"] = "OK";
  ArExceptionFlag2["VARIANCE_NON_ZERO"] = "VARIANCE_NON_ZERO";
  ArExceptionFlag2["MISSING_IN_QBO"] = "MISSING_IN_QBO";
  ArExceptionFlag2["MISSING_IN_CLIO"] = "MISSING_IN_CLIO";
  ArExceptionFlag2["DUPLICATE"] = "DUPLICATE";
  ArExceptionFlag2["LOW_CONFIDENCE_MATCH"] = "LOW_CONFIDENCE_MATCH";
  return ArExceptionFlag2;
})(ArExceptionFlag || {});
var TrustReconciliationFlag = /* @__PURE__ */ ((TrustReconciliationFlag2) => {
  TrustReconciliationFlag2["OK"] = "OK";
  TrustReconciliationFlag2["MISSING_IN_QBO_BANK"] = "MISSING_IN_QBO_BANK";
  TrustReconciliationFlag2["MISSING_IN_QBO_LIABILITY"] = "MISSING_IN_QBO_LIABILITY";
  TrustReconciliationFlag2["MISSING_IN_BOTH_QBO"] = "MISSING_IN_BOTH_QBO";
  TrustReconciliationFlag2["MISSING_IN_CLIO"] = "MISSING_IN_CLIO";
  TrustReconciliationFlag2["DUPLICATE"] = "DUPLICATE";
  return TrustReconciliationFlag2;
})(TrustReconciliationFlag || {});
var MatterTransactionType = /* @__PURE__ */ ((MatterTransactionType2) => {
  MatterTransactionType2["BILL"] = "bill";
  MatterTransactionType2["PAYMENT"] = "payment";
  MatterTransactionType2["TRUST_DEPOSIT"] = "trust_deposit";
  MatterTransactionType2["TRUST_WITHDRAWAL"] = "trust_withdrawal";
  MatterTransactionType2["TRUST_TRANSFER"] = "trust_transfer";
  MatterTransactionType2["ADJUSTMENT"] = "adjustment";
  return MatterTransactionType2;
})(MatterTransactionType || {});
var MatterReportType = /* @__PURE__ */ ((MatterReportType2) => {
  MatterReportType2["LEDGER"] = "ledger";
  MatterReportType2["STATEMENT"] = "statement";
  return MatterReportType2;
})(MatterReportType || {});
export {
  ArExceptionFlag,
  InvoiceStatus,
  LoginProvider,
  MatterReportType,
  MatterTransactionType,
  Status,
  TrustReconciliationFlag,
  UserRole
};
//# sourceMappingURL=index.js.map